module.exports = __webpack_public_path__ + "static/sunkenForest.30b61701.jpg";